import { formatHistoryDate } from '@/app/utils/supportRequest'

interface ChatSystemEventProps {
  text: string
  date: string
}

export const ChatSystemEvent = ({ text, date }: ChatSystemEventProps) => (
  <p className="py-1 text-center text-[11px] text-black04">
    {text} · {formatHistoryDate(date)}
  </p>
)
